import { ref, computed } from 'vue';
import { useToast } from '@travelata-libs/ui-kit';
import { LeadBannerPayload } from '@travelata-libs/ui-shared';
import registerModule from '@fr/vue/services/registerModule';
import getStore from '@fr/vue/services/getStore/getStore';
import { useState, useMutations } from 'vuex-composition-helpers';
import LeadStore, { NAMESPACE, StoreLeadState } from '../model/store';
import { createLead } from '../api';
import { setLeadCookie } from './cookie';


export default function(mobile: boolean) {
    const store = getStore();
    registerModule.register(store, LeadStore, NAMESPACE);
    const leadState = useState<StoreLeadState>(NAMESPACE, ['isSubmitted', 'model', 'loading']);
    const { setModel, setLoading, setSubmitted } = useMutations(NAMESPACE, ['setModel', 'setLoading', 'setSubmitted'])
    const formRef = ref<{ closeModal: () => {} } | null>(null);
    const { showToast } = useToast();

    const isSubmitted = computed({
        get: () => leadState.isSubmitted.value,
        set: (value) => setSubmitted(value),
    });

    const loading = computed({
        get: () => leadState.loading.value,
        set: (value) => setLoading(value),
    });

    const model = computed({
        get: () => leadState.model.value,
        set: (value) => setModel(value),
    });

    const onSubmit = async (data: LeadBannerPayload) => {
        isSubmitted.value = false;
        loading.value = true;
        try {
            await createLead(data);
            setLeadCookie();
            isSubmitted.value = true;
            formRef.value?.closeModal();
        } catch {
            showToast({
                mobile,
                type: 'error',
                title: 'Что-то пошло не так',
                description: 'Заявка не отправлена. Попробуйте ещё раз.'
            })
        } finally {
            loading.value = false;
        }
    };

    return {
        onSubmit,
        isSubmitted,
        model,
        formRef,
        loading,
    }
}